// Module
var code = "<a ng-if=\"!match.model.id\"> <h5>{{ \"Entities.EquipmentFunctionalityType.CreateNew\" | translate }}</h5> </a> <a ng-if=\"match.model.id\"> <table> <tr> <td> <div ng-bind-html=\"match.model.displayName | uibTypeaheadHighlight:query\"></div> </td> </tr> </table> </a> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/EquipmentType/EquipmentFunctionalities/FindAddFunctionality/FindFunctionalityResultTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;